export const MAX_SELECTION_NUMBER_OF_COLORS = 3;

export enum BrandImageType {
  LOGO = 1,
  PRIMARY_LOGO = 2,
}

export enum BrandColorType {
  PRIMARY = 1,
  SECONDARY,
  OTHER,
}

export enum BrandAssetType {
  BRAND_LOGOS = 1,
  BRAND_COLORS,
  BRAND_FONTS,
}

export enum BrandActivitySubjectType {
  SUBJECT_BRAND_LOGOS = 1,
  SUBJECT_BRAND_COLORS,
  SUBJECT_BRAND_FONTS,
  SUBJECT_BRAND_KIT,
}

export enum BrandActivityType {
  ADDED = 1,
  UPDATED,
  DELETED,
  ADDED_FROM_WEBSITE = 5,
}

export interface Brand {
  brandId: string;
  idteam: string;
  name: string;
  creatorId: number;
  isDeleted: number;
  doesBrandHaveAllAssetTypes: boolean;
  source?: BrandKitSource;
}

export interface ContentStateForSingleBrandKit {
  fonts: {
    loaded: number;
    ids: number[];
  };
  colors: {
    loaded: number;
    ids: number[];
  };
  logos: {
    loaded: number;
    ids: number[];
  };
}

export type BrandContent = Record<string, ContentStateForSingleBrandKit>;

export interface BrandActivityMap {
  [brandId: string]: {
    loaded: number;
    ids: number[];
  };
}

export interface BrandColor {
  idbrandColor: number;
  brandId: string;
  hexCode: string;
  type: BrandColorType;
}

export interface BrandFont {
  idbrandFont: number;
  brandId: string;
  idfont: number;
  defaultColor: string;
  fontFamily: string;
  isInternalFont: boolean;
  brandFontName: string;
  isDeleted: number;
  fontType: FontType;
}

export interface BrandLogo {
  id: number;
  filename: string;
  ext: string;
  src: string;
  hasTransparency: boolean;
  uploaderId: number;
  uploaderName: string;
  width: string;
  height: string;
  idbrandImage: number;
  brandId: string;
  brandImageType: BrandImageType;
}

export interface SelectableState {
  selectedColors: {
    ids: SelectableColorIds;
    defaultSelected: boolean;
  };
  selectedLogo: {
    id: number;
    defaultSelected: boolean;
  };
}

export enum BrandsLoadingState {
  NOT_LOADED = 1,
  LOADING = 2,
  LOADED = 3,
}

export interface SelectableColorHexes {
  Primary: string;
  Secondary: string;
  Tertiary: string;
}

export interface BrandsAppState {
  brands: Brand[];
  activeBrandId: ActiveBrandId;
  brandContent: BrandContent;
  brandActivityMap: BrandActivityMap;
  brandActivity: Record<string, unknown>; // Replace 'unknown' with the actual type
  brandActivityDetails: Record<string, unknown>; // Replace 'unknown' with the actual type
  brandsLoadingState: BrandsLoadingState;
  isUserTeamAdmin: boolean;
  showNewBrandMobileWizard: boolean;
  fonts: Record<string, unknown>; // Replace 'unknown' with the actual type
  colors: Record<string, BrandColor>;
  logos: Record<string, BrandLogo>;
  selectableState: SelectableState;
}

export interface BrandKitWithAssets {
  brandKit: Brand;
  colors: BrandColor[];
  fonts: BrandFont[];
  logos: BrandLogo[];
}

export type BrandKitsWithAssetsMap = Record<string, BrandKitWithAssets>;

export type ActiveBrandId = string | null;

/* Selectable Brand Kits enums */
export const SELECTABLE_COLOR_EMPTY = -1;

export const EMPTY_SELECTABLE_COLORS_STATE = {
  Primary: SELECTABLE_COLOR_EMPTY,
  Secondary: SELECTABLE_COLOR_EMPTY,
  Tertiary: SELECTABLE_COLOR_EMPTY,
};

export interface SelectableColorIds {
  Primary: number;
  Secondary: number;
  Tertiary: number;
}

export enum BrandColorSelectionIndex {
  PRIMARY = 'Primary',
  SECONDARY = 'Secondary',
  TERTIARY = 'Tertiary',
}

/* End selectable Brand Kits enums */

export interface RootStateWithBrandsRedux {
  brands: BrandsAppState;
}

export interface BrandKitsRejectedThunkResponse {
  error: Error;
  payload: {
    status: string;
    data: {
      redirectTo?: string;
    };
  };
}

export enum BrandKitSource {
  USER = 'user',
  WEBSITE = 'website',
  HALLOWEEN_PROMOTION_TEMPLATE = 'halloween-t',
  HALLOWEEN_PROMOTION = 'halloween'
}

export enum FontType {
  OTHER = 1,
  HEADING = 2,
  BODY = 3,
}
